import EmployeeShortProfile from "../employeeShortProfile/EmployeeShortProfile";
import "./ProfileSubHeaderLinks.css";
import { getSessionItem } from "../../utils/helper/session";

function ProfileSubHeaderLinks({ user }) {
  const currentUser = user ?? getSessionItem("User");

  if (!currentUser) {
    return null;
  }

  return (
    <div className="profile-subheader">
      <EmployeeShortProfile
        employeeName={`${currentUser.firstName ?? ""} ${currentUser.lastName ?? ""}`.trim()}
        employeePronoun={currentUser.pronoun}
        employeeDesignation={currentUser.jobDescription}
        employeeID={currentUser.id}
        employeeUsername={currentUser.email || currentUser.username}
        employeeLocation={currentUser.city}
        employeePicture={currentUser.image}
        employeeDepartment={currentUser.department}
        employeeIdvStatus={getSessionItem("trolleyIdvStatus")}
      />
    </div>
  );
}

export default ProfileSubHeaderLinks;